/* eslint-disable react/forbid-prop-types */
/* eslint-disable no-restricted-syntax */
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import PropTypes from 'prop-types';
import { useMutation } from 'react-query';
import ModalBodyLayout from '../../../shared/ModalBodyLayout';
import BasicContainer from '../../../../components/BasicContainer';
import CurrencyIcon from '../../../../components/CurrencyIcon';
import { CARD_CASHBACK_CURRENCY_UPDATE } from '../../mutations';
import { showAlert } from '../../../../utilities/notifications';
import { useUsEnv } from '../../../../utilities/sharedHooks/useUsEnv';

const SelectCashbackCurrency = ({ onCloseModal, allowedCurrencies, setIsCashbackChanged }) => {
  const { t: translate } = useTranslation();
  const [selectedCurrency, setSelectedCurrency] = useState('');
  const [cashbackChangedSuccess, setCashbackChanged] = useState(false);

  const coins = Object.values(allowedCurrencies);

  const { isUsEnv } = useUsEnv();

  const { mutate: updateCashbackCurrency } = useMutation(CARD_CASHBACK_CURRENCY_UPDATE, {
    onSettled: (data, error) => {
      if (error) {
        showAlert({ message: error.message, type: 'danger' });
      } else {
        setCashbackChanged(!cashbackChangedSuccess);

        if (onCloseModal) {
          onCloseModal();
        }
      }
    },
  });

  useEffect(() => {
    if (cashbackChangedSuccess) {
      setIsCashbackChanged(cashbackChangedSuccess);
      showAlert({
        message: translate(
          isUsEnv
            ? 'loyalty_program_cashback_currency_updated_successfully_us_message'
            : 'loyalty_program_cashback_currency_updated_successfully_message'
        ).replace('__CURRENCY__', selectedCurrency),
        type: 'success',
      });
    }
  }, [cashbackChangedSuccess, isUsEnv, selectedCurrency, setIsCashbackChanged, translate]);

  const handleOnClick = (coin) => {
    setSelectedCurrency(coin?.currency_display_name);
    updateCashbackCurrency({ cashback_currency: coin?.id });
  };

  const renderWalletItem = (coin) => (
    <BasicContainer
      className="bg-light cursor-pointer hover-container mb-2 "
      key={coin?.id}
      onClick={() => handleOnClick(coin)}>
      <div className="d-flex flex-row align-items-center justify-content-between">
        <CurrencyIcon
          currencyCode={coin?.currency_display_name}
          style={{ width: '1.6rem', height: '1.6xrem' }}
        />
        <div className="col-9 ms-1">
          <p>
            <b>{coin?.currency_display_name}</b>
          </p>
          <p className="text-f6 text-shadow">
            {translate(
              isUsEnv
                ? 'loyalty_program_cashback_currency_us_percent'
                : 'loyalty_program_cashback_currency_percent'
            ).replace('__PERCENT__', coin?.cashback_reward_percent)}
          </p>
        </div>
        <i
          style={{ width: '1rem' }}
          className="icon icon-arrow-next-navigation text-primary text-f4 cursor-pointer"
          role="button"
          aria-label={coin?.currency_display_name}
          tabIndex={0}
          onKeyDown={() => {}}
          onClick={() => {}}
        />
      </div>
    </BasicContainer>
  );

  return (
    <ModalBodyLayout
      withBack={false}
      title={translate(
        isUsEnv
          ? 'select_coin_to_receive_cashback_us_title'
          : 'select_coin_to_receive_cashback_title'
      )}>
      <div className="wallet-list my-4 ">{coins.map((coin) => renderWalletItem(coin))}</div>
    </ModalBodyLayout>
  );
};

export default SelectCashbackCurrency;

SelectCashbackCurrency.propTypes = {
  onCloseModal: PropTypes.func.isRequired,
  allowedCurrencies: PropTypes.object.isRequired,
  setIsCashbackChanged: PropTypes.func,
};

SelectCashbackCurrency.defaultProps = {
  setIsCashbackChanged: null,
};
